export function cosmicBackgroundStyle(): string {
	return 'linear-gradient(to bottom, rgba(15,15,15,0.2), rgba(0,0,0,0.5)), url(/minimal_dark_space.png) center center / cover no-repeat fixed';
}
export function inlineIcon(name: string): string { return `<svg role="img" aria-label="${name}" viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="11" cy="11" r="7"/><path d="m16 16 5 5"/></svg>`; }
